import dashboardService from "@services/dashboard.service";
import { useCalenderViewStore } from "@stores/useCalenderViewStore";
import { Badge, Button, Drawer } from "antd";
import { cloneDeep, forEach } from "lodash";
import React, { FC, useEffect, useState } from "react";
import { filterPayload } from "../../calendarUtils";
import FilterForMonthCalender from "../FilterForMonthCalender/filterForMonthCalender";

import "./monthFilter.scss";

const MonthFilter: FC<any> = () => {
  const layerViews = [
    {
      label: "Filters:",
      key: "filter",
      width: "300",
      padding: 0,
      className: "filtersDrawer",
    },
  ];

  const monthFilter = useCalenderViewStore((state) => state.monthFilter);
  const setMonthFilter = useCalenderViewStore((state) => state.setMonthFilter);
  const applyFilterFlag = useCalenderViewStore((state) => state.applyFilterFlag);
  const setApplyFilterFlag = useCalenderViewStore((state) => state.setApplyFilterFlag);
  const isFilterMonthApplied = useCalenderViewStore((state) => state.isFilterMonthApplied);
  const setIsFilterMonthApplied = useCalenderViewStore((state) => state.setIsFilterMonthApplied);

  const dependenceFilterKey = useCalenderViewStore((state) => state.dependenceFilterKey);
  const setDependenceFilterKey = useCalenderViewStore((state) => state.setDependenceFilterKey);
  const dependenceFilterObject = useCalenderViewStore((state) => state.dependenceFilterObject);
  const setDependenceFilterObject = useCalenderViewStore((state) => state.setDependenceFilterObject);
  const selectedActiveMonthFilters = useCalenderViewStore((state) => state.selectedActiveMonthFilters);
  const setSelectedActiveMonthFilters = useCalenderViewStore((state) => state.setSelectedActiveMonthFilters);

  const [isOpenDrawer, toggleDrawerHandler] = useState(false);
  const [masterFilterDataMonth, setMasterFilterDataMonth] = useState<any>([]);
  const [copyMasterFilterDataMonth, setCopyMasterFilterDataMonth] = useState<any>([]);
  const [copyMasterFilterDataMonthSearch, setCopyMasterFilterDataMonthSearch] = useState<any>([]);
  const [copyMonthFilter, setCopyMonthFilter] = useState(cloneDeep(monthFilter));
  const [copyDependenceFilterKey, setCopyDependenceFilterKey] = useState<any>(dependenceFilterKey);
  const [copyDependenceFilterObject, setCopyDependenceFilterObject] = useState<any>(dependenceFilterObject);
  // const [selectedActiveFilters, setSelectedActiveFilters] = useState<string[]>([]);
  // const [copySelectedActiveFilters, setCopySelectedActiveFilters] = useState<string[]>([]);

  const [monthFiltersOnChange, setMonthFiltersOnChange] = useState(false);
  const [isloadingFilter, setIsloadingFilter] = useState(false);
  const [preLoadFilterOnIcon, setPreLoadFilterOnIcon] = useState(false);
  const [unSavedFilterSetFlag, setUnSavedFilterSetFlag] = useState(false);
  const [unSavedFilterSetFlagForClear, setUnSavedFilterSetFlagForClear] = useState(false);
  useEffect(() => {
    console.log("MonthFilter.useEffect"); 
    getMonthFilter()
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [monthFiltersOnChange, unSavedFilterSetFlag]);

  const getMonthFilter = () => {
    console.log("MonthFilter.getMonthFilter");
    setCopyMonthFilter(unSavedFilterSetFlagForClear ? copyMonthFilter : monthFilter);
    setIsloadingFilter(true);
    setPreLoadFilterOnIcon(true);
    let filters = filterPayload(unSavedFilterSetFlagForClear ? copyMonthFilter : monthFilter);
    let flag = isFiltersApplied(unSavedFilterSetFlagForClear ? copyMonthFilter : monthFilter);
    flag ? setIsFilterMonthApplied(true) : setIsFilterMonthApplied(false);

    dashboardService.fetchCalenderViewMonthFilter(filters).subscribe({
      next: (v) => {

        let tempMasterSelectedData = v?.data?.data?.result?.map((filterObj: any) => {
          if (dependenceFilterKey === filterObj.columnName) {
            filterObj.filterValues = dependenceFilterObject;
          }
          return filterObj;
        });

        setMasterFilterDataMonth(tempMasterSelectedData);
        setCopyMasterFilterDataMonth(tempMasterSelectedData);
        setCopyMasterFilterDataMonthSearch(tempMasterSelectedData);
        /////////////////////////////////////////////////////////////////////

        let localCopy_copyMonthFilter = unSavedFilterSetFlagForClear ? cloneDeep(copyMonthFilter) : cloneDeep(monthFilter);

        let temp_masterFilterDataMonth = cloneDeep(masterFilterDataMonth);
        forEach(masterFilterDataMonth, (localMonthFilter, index) => {
          let localFilterOptions = localMonthFilter.filterValues;
          localFilterOptions = localFilterOptions.filter((opt: any) => localCopy_copyMonthFilter[localMonthFilter.columnName].indexOf(opt) === -1);
          localFilterOptions = [...localCopy_copyMonthFilter[localMonthFilter.columnName], ...localFilterOptions];
          temp_masterFilterDataMonth[index].filterValues = localFilterOptions;
        });
        // setCopyMasterFilterDataMonthSearch(temp_masterFilterDataMonth);

        setUnSavedFilterSetFlagForClear(false);
        setIsloadingFilter(false);
        setPreLoadFilterOnIcon(false);
      },
      error: (e) => {
        console.log(e);
        setIsloadingFilter(false);
        setPreLoadFilterOnIcon(false);
      },
    });
  };

  //Selected Active Items for filter
  const selectedPanels = (onAction:any) => {
    let tempSelectedActiveFilters:any = [];
    if(onAction==="onApply")tempSelectedActiveFilters = Object.keys(copyMonthFilter).filter((filters: any) => copyMonthFilter[filters].length > 0);
    if(onAction==="onClose")tempSelectedActiveFilters = Object.keys(monthFilter).filter((filters: any) => monthFilter[filters].length > 0);
    // setSelectedActiveFilters(tempSelectedActiveFilters);
    setSelectedActiveMonthFilters(tempSelectedActiveFilters);
  };

  const onCollapseChange = (key:any) => {
    setSelectedActiveMonthFilters([...key]);
  }

  const onOptionSelection = (selectedArray: any, index: any, filterColumn: any, options: any) => {
    setIsloadingFilter(true);
    let localCopy_copyMonthFilter = cloneDeep(copyMonthFilter);
    localCopy_copyMonthFilter[filterColumn] = selectedArray;
    setCopyMonthFilter(localCopy_copyMonthFilter);
    let localFilteredNewData: any[] = [];
    let tempListForDependence = cloneDeep(dependenceFilterKey);
    let tempListForDependenceObject = cloneDeep(dependenceFilterObject);
    if (selectedArray.length > 0 && !(dependenceFilterKey === filterColumn)) {
      tempListForDependence = filterColumn;
      tempListForDependenceObject = options;
      setDependenceFilterKey(tempListForDependence);
      setDependenceFilterObject(tempListForDependenceObject);
      setCopyDependenceFilterKey(tempListForDependence);
      setCopyDependenceFilterObject(tempListForDependenceObject);      
    } else if (selectedArray.length === 0 && dependenceFilterKey === filterColumn) {
      tempListForDependence = "";
      tempListForDependenceObject = [];
      setDependenceFilterKey(tempListForDependence);
      setDependenceFilterObject(tempListForDependenceObject);
      setCopyDependenceFilterKey(tempListForDependence);
      setCopyDependenceFilterObject(tempListForDependenceObject);
    }

    dashboardService.fetchCalenderViewMonthFilter(filterPayload(localCopy_copyMonthFilter)).subscribe({
      next: (v) => {
        let tempMasterSelectedData = v?.data?.data?.result?.map((filterObj: any) => {
          if (tempListForDependence === filterObj.columnName) {
            filterObj.filterValues = tempListForDependenceObject;
          }
          return filterObj;
        });
        let localFilterForMonth = cloneDeep(localCopy_copyMonthFilter);
        forEach(tempMasterSelectedData, (item: any) => {
          let temp = localFilterForMonth[item.columnName].filter((filterMapItem: any) => item.filterValues.includes(filterMapItem));
          localFilterForMonth[item.columnName] = temp;
        });
        setCopyMonthFilter(localFilterForMonth);
        setMasterFilterDataMonth(tempMasterSelectedData);
        setCopyMasterFilterDataMonth(tempMasterSelectedData);
        setCopyMasterFilterDataMonthSearch(tempMasterSelectedData);
        localFilteredNewData = tempMasterSelectedData;
        setIsloadingFilter(false);
      },
      error: (e) => {
        console.log(e);
        setIsloadingFilter(false);
      },
    });

    let temp_masterFilterDataMonth = cloneDeep(localFilteredNewData);
    if (temp_masterFilterDataMonth.length > 0) {
      let temp1_masterFilterDataMonth = temp_masterFilterDataMonth[index].filterValues.filter((monthOption: any) => {
        return selectedArray.indexOf(monthOption) === -1;
      });
      temp1_masterFilterDataMonth = [...selectedArray, ...temp1_masterFilterDataMonth];
      temp_masterFilterDataMonth[index].filterValues = temp1_masterFilterDataMonth;
    } else {
    }
    // setCopyMasterFilterDataMonthSearch(temp_masterFilterDataMonth);
  };

  const onOptionSearch = (e: any, index: any, filterColumnName: any) => {
    let searchText = e.target.value;
    let localCopy_copyMonthFilter = cloneDeep(copyMonthFilter);
    let temp_masterFilterDataMonth = cloneDeep(masterFilterDataMonth);

    let temp1_masterFilterDataMonth = temp_masterFilterDataMonth[index].filterValues.filter((monthOption: any) => {
      return monthOption.toLowerCase().includes(searchText) && localCopy_copyMonthFilter[filterColumnName].indexOf(monthOption) === -1;
    });
    temp_masterFilterDataMonth[index].filterValues = [...localCopy_copyMonthFilter[filterColumnName], ...temp1_masterFilterDataMonth];
    setCopyMasterFilterDataMonth(temp_masterFilterDataMonth);
    // setCopyMasterFilterDataMonthSearch(temp_masterFilterDataMonth);
  };

  const applyFilter = () => {
    setMonthFilter(copyMonthFilter);
    let flag = isFiltersApplied(copyMonthFilter);
    flag ? setIsFilterMonthApplied(true) : setIsFilterMonthApplied(false);
    setApplyFilterFlag(!applyFilterFlag);
    selectedPanels("onApply");
    toggleDrawer();
  };

  const toggleDrawer = () => {
    toggleDrawerHandler(!isOpenDrawer);
  };

  const onCloseConfigDrawer = () => {
    setDependenceFilterKey(copyDependenceFilterKey);
    setDependenceFilterObject(copyDependenceFilterObject);
    setUnSavedFilterSetFlag(!unSavedFilterSetFlag);
    selectedPanels("onClose");
    toggleDrawer();
  };

  const drawerFooter = () => {
    return (
      <div style={{ textAlign: "right" }} className="cancel-button">
        <Button type="text" size="large" onClick={onCloseConfigDrawer}>
          Cancel
        </Button>
        <Button type="primary" className="apply-filter" style={{ height: "40px" }} onClick={applyFilter}>
          Apply Filter
        </Button>
      </div>
    );
  };
  const clearFilterHandler = () => {
    // setMonthFilter({ vintage: [], state: [], brand: [], office_active_status: [], office_name: [], provider_type: [], provider_name: [] });
    setCopyMonthFilter({ vintage: [], state: [], brand: [], office_active_status: [], office_name: [], provider_type: [], provider_name: [] });
    setCopyDependenceFilterKey(dependenceFilterKey);
    setCopyDependenceFilterObject(dependenceFilterObject);
    setDependenceFilterKey([]);
    setDependenceFilterObject([]);
    setUnSavedFilterSetFlagForClear(true);
    setMonthFiltersOnChange(!monthFiltersOnChange);
    setSelectedActiveMonthFilters([]);
    // setApplyFilterFlag(!applyFilterFlag);
    // let flag = isFiltersApplied();
    // flag ? setIsFilterMonthApplied(true) : setIsFilterMonthApplied(false);
    // toggleDrawer();
  };

  const drawerHeader = () => {
    return (
      <Button type="link" onClick={clearFilterHandler} className="clr-e100" style={{ fontWeight: "normal" }}>
        Clear All
      </Button>
    );
  };

  const isFiltersApplied = (filterProp: any) => {
    let presentFlag = false;
    let localFilterForMonth = cloneDeep(filterProp);
    forEach(Object.keys(localFilterForMonth), (filterKeys) => {
      if (localFilterForMonth[filterKeys].length > 0) {
        presentFlag = true;
        return;
      }
    });
    if (presentFlag) return true;
    else return false;
  };

  const drawerView = () => {
    return (
      <FilterForMonthCalender
        masterFilterDataMonth={copyMasterFilterDataMonth}
        onOptionSelection={onOptionSelection}
        copyMonthFilter={copyMonthFilter}
        onOptionSearch={onOptionSearch}
        isloadingFilter={isloadingFilter}
        copyMasterFilterDataMonthSearch={copyMasterFilterDataMonthSearch}
        selectedActiveFilters={selectedActiveMonthFilters}
        onCollapseChange={onCollapseChange}
      />
    );
  };

  //////////

  return (
    <>
      <Badge dot={isFilterMonthApplied} offset={[-12, 12]}>
        {!preLoadFilterOnIcon ? (
          <span
            className={`btn-icon ${preLoadFilterOnIcon ? `` : "icon-filter"} clr-n125 ${isFilterMonthApplied ? "tableFilterApplied" : ""} `}
            style={{ height: "42px" }}
            onClick={(e) => {
              e.stopPropagation();
              if (!preLoadFilterOnIcon) toggleDrawerHandler(!isOpenDrawer);
            }}
          />
        ) : (
          <span
            className={`btn-icon clr-n125 ${isFilterMonthApplied ? "tableFilterApplied" : ""} `}
            style={{ height: "42px", width: "42px", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <div className="monthFilter_preLoader shimmerBG" />
          </span>
        )}
      </Badge>
      <Drawer
        destroyOnClose={true}
        title={layerViews[0].label}
        placement="right"
        closable={false}
        // maskClosable={false}
        onClose={onCloseConfigDrawer}
        visible={isOpenDrawer}
        key="right"
        width={layerViews[0].width}
        bodyStyle={{ padding: layerViews[0].padding }}
        className={`membersListingDrawer ${layerViews[0].className}`}
        footer={drawerFooter()}
        extra={drawerHeader()}
      >
        {drawerView()}
      </Drawer>
    </>
  );
};

export default MonthFilter;
